export default "__VITE_ASSET__6dEhfOQY__"